import {Stack} from '@mui/material'
import React, {useState} from 'react'
import Label from '../../../customTable/Label'
import {useTranslation} from 'react-i18next'
import MainBtn from '../../../customTable/MainBtn'
import {useSelector, useDispatch} from 'react-redux'
import {RootState} from '../../../../store'
import Product from '../../../../Api/product'
import {useParams} from 'react-router-dom'
import Link from './Link'
import {actionsProducts} from '../../../../store/vender/products/slice'

export default function Videos({formik}: any) {
  const {product} = useSelector((state: RootState) => state.product)
  const dispatch = useDispatch()

  const {t} = useTranslation()
  const store = useSelector((state: RootState) => state.vender)
  const [isLoading, setIsLoading] = useState(false)
  const {id} = useParams()
  const [val, setVal] = useState('')
  const [err, setErr] = useState<string>('')

  // يقبل فقط: https://www.youtube.com/watch?v=XXXXXXXXXXX
  // ويرفض: https://www.youtube.com/shorts/XXXXXXXXXXX أو أي دومين/مسار مختلف
  const isValidRegularYoutube = (url: string) => {
    const trimmed = url.trim()
    const shortsRegex = /^https?:\/\/(www\.)?youtube\.com\/shorts\/[\w-]{11}(?:[/?#].*)?$/i
    if (shortsRegex.test(trimmed)) return false

    const regularWatchRegex =
      /^https?:\/\/(www\.)?youtube\.com\/watch\?(?:.*&)?v=([\w-]{11})(?:[&#].*)?$/i

    const m = trimmed.match(regularWatchRegex)
    if (!m) return false

    // تأكد أن قيمة v هي أولية وصحيحة الطول 11
    const videoId = m[2]
    return typeof videoId === 'string' && videoId.length === 11
  }

  const add = () => {
    const link = val.trim()
    if (!isValidRegularYoutube(link)) {
      setErr('videoNote')
      return
    }

    setErr('')
    if (!isLoading) {
      Product.storeVideo(
        {product_id: id, video: link},
        (res: any) => {
          setVal('')
          if (product && product.product_pictures) {
            dispatch(
              actionsProducts.setProduct({
                ...product,
                product_pictures: [...product.product_pictures, res] || [],
              })
            )
          } else {
            dispatch(
              actionsProducts.setProduct({
                ...product,
                product_pictures: [res],
              })
            )
          }
        },
        setIsLoading
      )
    }
  }

  const isDisabled = val.trim() === '' || !isValidRegularYoutube(val)

  return (
    <Stack minHeight={'300px'} gap='8px' p='0 29.25px'>
      <Label text='addVideo' />

      <Stack position={'relative'}>
        <input
          value={val}
          onChange={(e: any) => {
            setVal(e.target.value)
            // تحقّق فوري لإظهار/إخفاء الخطأ أثناء الكتابة
            const v = e.target.value as string
            if (v.trim() === '') {
              setErr('')
            } else if (!isValidRegularYoutube(v)) {
              setErr('videoNote')
            } else {
              setErr('')
            }
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault()
              add()
            }
          }}
          placeholder={`${t('videoLink')}`}
          style={{
            outline: 'none',
            border: err ? '1px solid #d32f2f' : '1px solid #D8D8D8',
            borderRadius: '8px',
            padding: '16px',
          }}
        />

        {/* زر الإرسال */}
        <Stack
          top='8px'
          right={store.isRtl === 0 ? '10px' : 'auto'}
          left={store.isRtl !== 0 ? '10px' : 'auto'}
          position={'absolute'}
        >
          <MainBtn
            disabled={isDisabled}
            isLoading={isLoading}
            handelSubmit={add}
            color='#405189'
            bgcolor='#d7d7d7'
            width='fit-content'
            text='submitVideo'
          />
        </Stack>
      </Stack>

      {/* رسالة توضيح/خطأ */}
      <Label fs='10px' color={err ? '#d32f2f' : '#8f8f8f'} text={err ? err : 'videoNote'} />

      {/* قائمة الفيديوهات */}
      <Stack gap='16px' mt='16px'>
        {product.product_pictures &&
          product.product_pictures
            .filter((e: any) => e.media_type === 'video')
            .map((e: any) => <Link key={e.id || e.media_id || e.link || Math.random()} link={e} />)}
      </Stack>
    </Stack>
  )
}
